export * from "./globals_common.mjs";

export const system = "production";
export const cookiesVersion = "1.1";
export const backgroundRefreshTimeoutMs = 60000;
export const backgroundRefreshTimeoutNotVisibleMs = 120000; // If e.g. another tab is selected
export const skipTwoFactorAuth = false
export const recaptchaSitekey = "6LexgzQsAAAAAJJPnk_tnYy5DwtW2WdROlzGquEc"
